module.exports = __webpack_public_path__ + "static/img/xinqingnian.146bca9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/xinqingnian.jpeg
// module id = URGC
// module chunks = 1